import { Component, ObjectManager } from '../../../concepts/objects';
import { ParticipantManager } from '../../canvas/participants/ParticipantManager';
import { resolve } from '../../Container';
import { DefineSimpleDimension } from '../dataExport/addons/SimpleDimension';
import { FromFirstMatchExportAdapter } from '../dataExport/ExportAdapter';
import { Sticky } from '../paper/Sticky';
import { Assignable } from './Assignable';
import { TaskRecordAttr } from './TaskAssocations';

export class AssociatedTaskExportAdapter extends FromFirstMatchExportAdapter {

    @resolve(ParticipantManager) private participants!: ParticipantManager;
    @resolve(ObjectManager) private objects!: ObjectManager;

    protected selector = (c: Component) => c.is(Sticky);

    public readonly id = 'TaskAssociations';
    public readonly label = 'Associations';
    public readonly columns = [
        DefineSimpleDimension(
            Sticky,
            'Action Owner',
            'Adds a column that contains the assignee of the associated Action Item.',
            (c: Component) => {
                const ac = c.as(Assignable);
                if (!ac) return null;
                const { userId } = TaskRecordAttr.get(ac) ?? {};
                if (!userId) return null;
                return this.participants.get(userId)?.name ?? '';
            }
        ),
        DefineSimpleDimension(
            Sticky,
            'Action Due Date',
            'Adds a column that contains the due date of the associated Action Item.',
            (c: Component) => {
                const ac = c.as(Assignable);
                if (!ac) return null;
                const { id, dueDate } = TaskRecordAttr.get(ac) ?? {};
                if (!id && !dueDate) return null;
                const [y, m, d] = dueDate?.split('-') ?? [];
                if (!y || !m || !d) return null;
                return new Date(Date.UTC(parseInt(y), parseInt(m) - 1, parseInt(d))).toLocaleDateString();
            }
        ),
    ];
}
